import { jsx as _jsx } from "react/jsx-runtime";
import SubHeader from '../SubHeader';
import { Routes } from '../../../../constants/routes';
import { useTranslation } from 'react-i18next';
const MyAccountSubHeader = () => {
    const { t } = useTranslation();
    const subHeaderData = [
        {
            name: t('my_account'),
            link: Routes.MY_ACCOUNT,
            disabled: false,
            parent: 'about'
        },
        {
            name: t('notifications'),
            link: Routes.NOTIFICATIONS,
            disabled: false,
            parent: 'notifications'
        }
    ];
    return _jsx(SubHeader, { data: subHeaderData });
};
export default MyAccountSubHeader;
